import React from 'react';

import PropTypes from 'prop-types';

import TextFieldField from './TextFieldField';

const DecimalField = ({ placeholder, textPlaceholder, ...props }) => (
  <TextFieldField
    {...props}
    commitAsNumber
    placeholder={placeholder || textPlaceholder}
    type="number"
    inputProps={{ step: 'any' }}
  />
);

DecimalField.propTypes = {
  data: PropTypes.shape({ title: PropTypes.string }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  isDiff: PropTypes.bool,
  placeholder: PropTypes.string,
  textPlaceholder: PropTypes.string,
  validate: PropTypes.func,
  savedError: PropTypes.string,
  onValidationChange: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};

DecimalField.defaultProps = {
  value: '',
  disabled: false,
  isDiff: false,
  placeholder: '',
  textPlaceholder: '',
  validate: null,
  savedError: null,
  onValidationChange: null,
};

export default DecimalField;
